<template>
  <div>
    <div class="page-title-container lighter-shadow">
      <i class="fas fa-car-side icon"></i>
      <h1 class="registration-number-title" v-text="carInfo.registrationNumber" v-if="!isCarLoading"></h1>
      <h1 v-text="carTitle" v-if="!isCarLoading"></h1>
    </div>
    <TabContainer :tabs="tabs"/>
    <div class="page-content lighter-shadow" style="margin-bottom: 50px;">
      <div class="tab-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import redirectService from "@/services/redirect.service";
import {mapGetters} from 'vuex';
import TabContainer from "@/shared/components/TabContainer";

export default {
  name: "CarInfo",
  components: {TabContainer},
  created() {
    if (this.$route.path === '/cars/' + this.carId) {
      redirectService.redirectToCarInfo(this.carId);
      return;
    }

    this.$store.dispatch('fetchCar', this.carId);
    this.$store.dispatch('fetchCarEnums');
  },
  data() {
    return {
      carId: this.$route.params.id,
      tabs: [
        {
          id: 'CarInfo',
          link: 'information',
          name: 'Информация',
          icon: 'fas fa-car-side',
        },
        {
          id: 'Vignettes',
          link: 'vignettes',
          name: 'Винетки',
          icon: 'fas fa-road'
        },
        {
          id: 'Documents',
          link: 'documents',
          name: 'Документи',
          icon: 'far fa-file-alt'
        },
        {
          id: 'Notes',
          link: 'notes',
          name: 'Бележки',
          icon: 'far fa-comment-alt'
        }
      ],
    }
  },
  methods: {},
  computed: {
    ...mapGetters(['carInfo', 'isCarLoading']),

    carTitle() {
      const brand = this.carInfo.brand ? this.carInfo.brand : '';
      const model = this.carInfo.model ? this.carInfo.model : '';
      return brand + ' ' + model;
    }
  },
  destroyed() {
    this.$store.commit('setCarInfo',{});
  }
}
</script>

<style scoped>
@import '../../css/shared/tabs.css';

.tab-content {
  width: 100%;
  float: left;
  box-sizing: border-box;
  padding: 25px;
}

.registration-number-title {
  margin-left: 40px;
  color: var(--light-primary-blue);
}
</style>
